import {
  Box,
  Stack,
  Typography,
  Grid,
  Chip,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import LoadingIndicator from '../../components/Global/loading-indicator/loading-indicator';
import { format } from 'date-fns';
import { convertNumberIntoCurrency } from '../Utilities/HelperMethods';

const StyledSectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
}));

const ViewClientInfo = ({
  data,
  versionData,
  versionInfo,
  isLoading,
  state,
  productLabel,
  planTypeLabel,
}) => {
  const versionISODate = versionInfo?.createdDate;
  const versionCreateDate = new Date(versionISODate);
  const versionFormatDate = versionISODate ? format(versionCreateDate, 'MM-dd-yyyy') : null;

  return (
    <Box sx={{ minHeight: '500px', p: 2 }}>
      <Stack spacing={3}>
        {isLoading ? (
          <LoadingIndicator />
        ) : (
          <>
            <Paper elevation={1} sx={{ p: 2 }}>
              <StyledSectionTitle variant="h5">Demographic Information</StyledSectionTitle>
              <Grid container spacing={2} mt={1}>
                <Grid size={6}>
                  <Typography variant="subtitle1">
                    <b>First Name</b>
                  </Typography>
                  <Typography variant="body1">{data?.firstName}</Typography>
                </Grid>
                <Grid size={6}>
                  <Typography variant="subtitle1">
                    <b>Last Name</b>
                  </Typography>
                  <Typography variant="body1">{data?.lastName}</Typography>
                </Grid>
                <Grid size={6}>
                  <Typography variant="subtitle1">
                    <b>Date Of Birth</b>
                  </Typography>
                  <Typography variant="body1">
                    {data?.dateOfBirth && format(new Date(data?.dateOfBirth), 'MM-dd-yyyy')}
                  </Typography>
                </Grid>
                <Grid size={6}>
                  <Typography variant="subtitle1">
                    <b>State</b>
                  </Typography>
                  <Typography variant="body1">{state}</Typography>
                </Grid>
                <Grid size={6}>
                  <Typography variant="subtitle1">
                    <b>Annuitant Name</b>
                  </Typography>
                  <Typography variant="body1">
                    {data?.annuitantFirstName} {data?.annuitantLastName}
                  </Typography>
                </Grid>
                <Grid size={6}>
                  <Typography variant="subtitle1">
                    <b>Annuitant Age</b>
                  </Typography>
                  <Typography variant="body1">{data?.annuitantAge}</Typography>
                </Grid>
                <Grid size={6}>
                  <Typography variant="subtitle1">
                    <b>Annuitant Gender</b>
                  </Typography>
                  <Typography variant="body1">
                    {data?.annuitantGender === 'M' ? 'Male' : 'Female'}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
            <Paper elevation={1} sx={{ p: 2 }}>
              <StyledSectionTitle variant="h5">Proposal Information</StyledSectionTitle>
              <Stack spacing={1} mt={1}>
                <Typography variant="body1">
                  <b>Version Name:</b> {versionInfo?.versionName || ' '}
                </Typography>
                {versionInfo?.createdDate && (
                  <Typography variant="body1">
                    <b>Version Date:</b> {versionFormatDate}
                  </Typography>
                )}
                <Typography variant="body1">
                  <b>Product:</b> {productLabel}
                </Typography>
              </Stack>
            </Paper>
            <Paper elevation={1} sx={{ p: 2 }}>
              <StyledSectionTitle variant="h5" sx={{ fontSize: '1.5rem' }}>
                Product Specifications
              </StyledSectionTitle>
              <Stack spacing={1} mt={1}>
                <Typography variant="body1">
                  <b>Effective Date:</b>{' '}
                  {versionData?.effectiveDate &&
                    format(new Date(versionData?.effectiveDate), 'MM-dd-yyyy')}
                </Typography>
                <Typography variant="body1">
                  <b>Plan Type:</b> {planTypeLabel}
                </Typography>
                <Typography variant="body1">
                  <b>Tax Status:</b> {versionData?.taxStatus || ''}
                </Typography>
                <Typography variant="body1">
                  <b>Single Premium ($):</b>{' '}
                  {versionData?.amount ? convertNumberIntoCurrency(versionData?.amount) : ''}
                </Typography>
              </Stack>
            </Paper>
            {versionData?.Riders?.length > 0 && (
              <Paper elevation={1} sx={{ p: 2 }}>
                <StyledSectionTitle variant="h5">Riders Information</StyledSectionTitle>
                <Stack
                  direction="column"
                  alignItems="flex-start"
                  spacing={1}
                  flexWrap="wrap"
                  mt={1}
                >
                  {versionData?.Riders?.map((rider, index) => (
                    <Chip
                      key={`${rider.name}-${index}`}
                      label={rider?.name}
                      color="primary"
                      variant="outlined"
                      sx={{ m: 1 }}
                    />
                  ))}
                </Stack>
              </Paper>
            )}
            {versionData?.withDrawls?.length > 0 && (
              <Paper elevation={1} sx={{ p: 2 }}>
                <StyledSectionTitle variant="h5">Withdrawals Information</StyledSectionTitle>
                <TableContainer component={Paper} sx={{ maxHeight: 200, mt: 1 }}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <b>Year</b>
                        </TableCell>
                        <TableCell>
                          <b>Amount</b>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {versionData?.withDrawls?.map((wt, index) =>
                        wt?.Amount ? (
                          <TableRow key={`${wt.Yr}-${index}`} hover>
                            <TableCell>{wt?.Yr}</TableCell>
                            <TableCell>{wt?.Amount}</TableCell>
                          </TableRow>
                        ) : null
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            )}
          </>
        )}
      </Stack>
    </Box>
  );
};
export default ViewClientInfo;
